<template>
    <v-card :loading="loading" class="pb-6">
        <v-card-title class="text-h5">
            <v-btn
                small
                icon
                @click="close"
                color="primary"
                class="ml-n3 mr-2 my-2 py-0"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>

            Event Details <v-spacer />
        </v-card-title>

        <v-divider class="ml-4 mr-5 mb-2" />

        <v-card-text class="pb-0">
            <v-tabs v-model="activeTab" class="mb-4">
                <v-tab>WO Progress</v-tab>

                <v-tab>Packing Progress</v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
                <v-tab-item>
                    <Progress
                        :projectId="null"
                        :project="null"
                        :eventWorkOrders="filteredWorkOrders"
                    />
                </v-tab-item>

                <v-tab-item>
                    <PackingProgress
                        :projectId="null"
                        :project="null"
                        :eventWorkOrders="filteredWorkOrders"
                        :calendarView="true"
                        :event="event"
                        :user="user"
                        :users="users"
                        :projects="projects"
                        @packingListUpdated="
                            $emit('packingListUpdated', $event)
                        "
                        @packingListDeleted="
                            $emit('packingListDeleted', $event)
                        "
                    />
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>
    </v-card>
</template>

<script>
import Progress from '@/components/WorkOrders/Progress.vue'
import PackingProgress from '@/components/Packing/PackingProgress.vue'

export default {
    name: 'EventDetails',
    components: {
        Progress,

        PackingProgress,
    },
    props: {
        event: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        users: {
            type: Array,
            required: true,
        },
        projects: {
            type: Array,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        expanded: [],
        activeTab: 0,
        elements: [],
        packingProcess: {
            id: 'packing',
            name: 'Packing',
        },
    }),
    computed: {
        filteredWorkOrders() {
            const workOrderCodes = new Set()
            ;(this.event?.elements || []).forEach(element => {
                if (
                    element.packingList &&
                    element.packingList.selectedWorkOrders
                ) {
                    element.packingList.selectedWorkOrders.forEach(wo => {
                        workOrderCodes.add(wo.code)
                    })
                }
            })
            return Array.from(workOrderCodes)
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}
.v-data-table {
    border: 1px solid #eeeeee;
}
</style>
